import { apiClient, type DriverUserExEntity } from '@/libs/api'

export type FetchDriverUserQuery = {
  tenantKey: string
  userId: number
}

export const fetchDriverUser = async (
  { tenantKey, userId }: FetchDriverUserQuery,
  signal?: AbortSignal
): Promise<DriverUserExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .driver_users._id(userId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
